import React from 'react';

const CTASection: React.FC = () => {
    return (
        <section className='py-8 px-4 -mt-36 relative z-10'>
            <div className="max-w-screen-xl mx-auto py-8 px-8 md:px-14 bg-light-yellow rounded-3xl grid md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6 items-center relative before:content-[''] before:h-full before:w-[95%] before:left-1/2 before:-translate-x-1/2 before:bg-main-blue/50 before:rounded-3xl before:absolute md:before:-rotate-2 before:-rotate-3 before:-z-10">
                <h2 className="font-semibold text-xl md:text-2xl text-balance md:col-span-2 lg:col-span-1">
                    A Uniexpo é a ponte que conecta jovens estudantes à escolha da profissão, ao seu futuro acadêmico e profissional.
                </h2>

                <div className="bg-main-pink text-white rounded-lg p-8 transition-all duration-200 hover:scale-105">
                    <h2 className="font-semibold text-2xl text-balance leading-6">
                        Seja um <br />
                        expositor
                    </h2>
                    <p className='font-light text-sm mt-3'>
                        Com mais de um milhão de estudantes impactados, a Uniexpo tem se consolidado como um dos maiores e mais importantes espaços para a escolha da profissão de estudantes do ensino médio"
                    </p>
                </div>

                <div className="bg-main-blue text-white rounded-lg p-8 transition-all duration-200 hover:scale-105">
                    <h2 className="font-semibold text-2xl text-balance leading-6">
                        Uniexpo <br />
                        no seu colégio
                    </h2>
                    <p className='font-light text-sm mt-3'>
                        Feira de profissões personalizada, focada nas necessidades dos seus estudantes, com o selo de qualidade que só uma marca consolidada como a Uniexpo pode oferecer.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default CTASection;